<template>
  <div>
    <el-row class="tool-bar-search-conditions">
      <span @click="toggleShowSearchConditions">
        フィルタリング条件
        <i :class="$root.allBarShowFlg ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </span>
    </el-row>
    <!-- 检索条件区域 -->
    <div class="search-conditions-container" v-if="$root.allBarShowFlg">
      <div class="search-conditions">
        <!-- 第一行 -->
        <div class="search-condition">
          <!-- 部門 -->
          <div class="search-condition-item department">
            <div class="item-label">
              <span>{{ this.$root.htmlConst.cons_232_department }}</span>
            </div>
            <el-select v-model="selected_categroy" class="item-select">
              <el-option v-for="item in categroy_list" :key="item.key" :label="item.value" :value="item">
              </el-option>
            </el-select>
          </div>
          <!-- 基準月 -->
          <div class="search-condition-item referenceMonth">
            <div class="item-label">
              <span>{{ this.$root.htmlConst.cons_225_reference_month }}</span>
            </div>
            <el-select v-model="selected_period" @change="selectChanged" class="item-select base-month-select">
              <el-option v-for="item in period_list" :key="item.key" :label="item.value" :value="item">
              </el-option>
            </el-select>
          </div>
          <!-- 担当範囲 -->
          <div class="search-condition-item scope">
            <div class="item-label">
              <span>{{ this.$root.htmlConst.cons_226_scope }}</span>
            </div>
            <el-select v-model="selected_member" class="item-select scope-select">
              <el-option v-for="item in member_list" :key="item.key" :label="item.value" :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 担当範囲 -->
        <!-- 第二行 - Response Type (Mode) with tags display on the right -->
        <div class="search-condition">
          <div class="search-condition-item responseType">
            <div class="item-label">
              <span>{{ this.$root.htmlConst.cons_227_response_type }}</span>
            </div>
            <el-select multiple collapse-tags v-model="mode" @change="getSelectMode" class="item-select">
              <el-checkbox v-model="checkedMode" @change="selectAllMode">すべて</el-checkbox>
              <el-option v-for="(item, index) in modes" :label="item.label" :value="item.value" :key="index">
              </el-option>
            </el-select>
          </div>
          <!-- Display selected mode items as colored tags on the right -->
          <div class="selected-tags-container" v-if="mode.length > 0">
            <el-tag
              v-for="(modeValue, index) in mode"
              :key="index"
              closable
              @close="removeMode(modeValue)"
              :style="{ backgroundColor: getModeColor(modeValue), color: getModeFontColor(modeValue), borderColor: getModeColor(modeValue) }"
              class="mode-tag"
            >
              {{ getModeLabel(modeValue) }}
            </el-tag>
          </div>
        </div>
        <!-- 第三行 - Facet with tags display on the right -->
        <div class="search-condition" v-if="false">
          <!-- ファセット -->
          <div class="search-condition-item facet">
            <div class="item-label">
              <span>{{ this.$root.htmlConst.cons_233_facet }}</span>
            </div>
            <el-select multiple collapse-tags v-model="facet" @change="getSelectFacet" class="item-select">
              <el-checkbox v-model="checkedFacet" @change="selectAllFacet">すべて</el-checkbox>
              <el-option v-for="(item, index) in facets" :label="item.label" :value="item.label"
                :key="index"></el-option>
            </el-select>
          </div>
          <!-- Display selected facet items as tags on the right -->
          <div class="selected-tags-container" v-if="facet.length > 0">
            <el-tag
              v-for="(facetLabel, index) in facet"
              :key="index"
              closable
              @close="removeFacet(facetLabel)"
              type="info"
              class="facet-tag"
            >
              {{ facetLabel }}
            </el-tag>
          </div>
        </div>
        <!-- 第四行 -->
        <div class="search-condition" v-if="false">
          <!-- 年代 -->
          <div class="search-condition-item age">
            <div class="item-label">
              <span>{{ this.$root.htmlConst.cons_234_age }}</span>
            </div>
            <el-select v-model="selected_age" @change="getSelectAge" class="item-select">
              <el-option v-for="(item, index) in ageArr" :key="index" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="search-condition-item gender "  v-if="false">
            <div class="item-label">
              <!-- 性別 -->
              <span>{{ this.$root.htmlConst.cons_235_sex }}</span>
            </div>
            <el-select v-model="selected_sex" @change="getSelectSex" class="item-select" clearable>
              <el-option v-for="(item, index) in sexArr" :key="index" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!--在宅/オフィス -->
          <div class="search-condition-item remote-office"  v-if="false">
            <div class="item-label">
              <!--在宅/オフィス -->
              <span>在宅/オフィス</span>
            </div>
            <el-select v-model="selected_workStatus" class="item-select" clearable>
              <el-option v-for="(item, index) in workStatus" :key="index" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 操作按钮 -->
        <div>
          <!-- 检索按钮 -->
          <el-button class="action action-search" type="primary" @click="toggleView">
            {{ this.$root.htmlConstRecording.cons_308_search_btn }}
          </el-button>
          <!-- 清除检索条件按钮 -->
          <el-button class="action action-clear" type="primary" @click="clearClick">
            {{ this.$root.htmlConstRecording.cons_201_btn_clear_jp }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
var moment = require("moment-timezone");
export default {
  name: "HistoryHeaderMenu",
  created() {
    api.getHtmlConst().then(
      (res) => {
        if (res && res.data) {
          let data = res.data;
          this.$root.htmlConst = data.htmlConst;
          if (this.$root.nameless == "display") {
            this.$root.unusedChartPresenceList = [];
            this.$root.usedChartPresenceList = [
              {
                name: "PresenceStatusChart",
                displayName: "応対稼働状況",
              },
              {
                name: "PresenceModeChart",
                displayName: "応対モード別稼働状況",
              },
              {
                name: "PresenceNgWordsAlertCount",
                // displayName: "NGワード（マナー）アラート人数",
                displayName: "要注意アラート件数",
              },
              {
                name: "PresenceLongTimeAlertCount",
                displayName: "長時間応対アラート件数",
              },
              {
                name: "PresenceSupervisorHelpAlertCount",
                displayName: this.$root.htmlConst.cons_107_sv_header,
              },
              // {
              //   name: "SuspectedAlertCount",
              //   displayName: this.$root.htmlConst.cons_108_claim_header,
              // },
              // {
              //   name: "PersonConfirmAlertCount",
              //   displayName: this.$root.htmlConst.cons_109_annoyances_header,
              // },
              // {
              //   name: "ForecastAlertCount",
              //   displayName: this.$root.htmlConst.cons_110_hitch_header,
              // },
            ];
          } else {
            this.$root.unusedChartPresenceList = [
              {
                name: "PersonConfirmAlertCount",
                displayName: this.$root.htmlConst.cons_109_annoyances_header,
              },
            ];
            this.$root.usedChartPresenceList = [
              {
                name: "PresenceStatusChart",
                displayName: "応対稼働状況",
              },
              {
                name: "PresenceModeChart",
                displayName: "応対モード別稼働状況",
              },
              {
                name: "PresenceNgWordsAlertCount",
                // displayName: "NGワード（マナー）アラート人数",
                displayName: "要注意アラート件数",
              },
              {
                name: "PresenceLongTimeAlertCount",
                displayName: "長時間応対アラート件数",
              },
              {
                name: "PresenceSupervisorHelpAlertCount",
                displayName: this.$root.htmlConst.cons_107_sv_header,
              },
              {
                name: "SuspectedAlertCount",
                displayName: this.$root.htmlConst.cons_108_claim_header,
              },
              {
                name: "ForecastAlertCount",
                displayName: this.$root.htmlConst.cons_110_hitch_header,
              },
            ];
          }
          if (localStorage.getItem('usedChartPresenceList')) {
            let localConfig = JSON.parse(localStorage.getItem('usedChartPresenceList'))
            this.$root.unusedChartPresenceList = this.$root.usedChartPresenceList.filter(item => localConfig.filter(ele => ele.name == item.name).length == 0)
            this.$root.usedChartPresenceList = this.$root.usedChartPresenceList.filter(item => localConfig.filter(ele => ele.name == item.name).length > 0)
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
    // this.selected_age = this.ageArr[0];
    // this.selected_sex = this.sexArr[0];
    let self = this;
    // const dataUrl = "";
    api.getCategoryList().then(
      (res) => {
        if (res && res.data) {
          self.categroy_list = res.data;
          self.selected_categroy = self.categroy_list[0];
        }
      },
      (err) => {
        console.log(err);
      }
    );
    api.getPeriodList().then(
      (res) => {
        if (res && res.data) {
          self.period_list = res.data;
          self.selected_period = self.period_list[0];
          this.$root.endDate = moment().format("YYYY-MM-DD");
          this.$root.startDate = moment(moment().format("YYYY-MM-DD"))
            .startOf("month")
            .format("YYYY-MM-DD");
        }
      },
      (err) => {
        console.log(err);
      }
    );
    api.getMemberList().then(
      (res) => {
        if (res && res.data) {
          self.member_list = res.data;
          self.selected_member = self.member_list[0];
        }
      },
      (err) => {
        console.log(err);
      }
    );
    api.getFacetList().then(
      (res) => {
        if (res && res.data) {
          let facetList = [];
          for (let facetItem of res.data) {
            facetList.push(facetItem.value);
          }
          self.default_facet = facetList;
          self.facet = [];
          self.facets = res.data;
          this.$root.facetForEchart = [];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  },

  data() {
    return {
      chatTableShowFlg: true,
      selected_categroy: this.selected_categroy,
      categroy_list: this.categroy_list,
      selected_period: this.selected_period,
      period_list: this.period_list,
      selected_member: this.selected_member,
      member_list: this.member_list,
      selected_mode: this.selected_mode,
      mode_list: this.mode_list,
      classify_list: this.classify_list,
      selected_classify: this.selected_classify,
      checked1: true,
      checked2: false,
      checked3: false,
      checked4: false,
      default_mode: ["チャットボット応対", "AIボイスボット応対","電話応対", "チャットサポート","F2F応対"],
      mode: ["チャットボット応対", "AIボイスボット応対","電話応対", "チャットサポート","F2F応対"],
      modes: [
        {
          value: "チャットボット応対",
          label: "AIチャットボット応対",
        },
        {
          value: "AIボイスボット応対",
          label: "AIボイスボット応対",
        },
        {
          value: "電話応対",
          label: "電話モード応対",
        },
        {
          value: "チャットサポート",
          label: "チャットモード応対",
        },
        {
          value: "F2F応対",
          label: "F2Fモード応対",
        },
      ],
      ageArr: [
        { value: "20代", label: "20代" },
        { value: "30代", label: "30代" },
        { value: "40代", label: "40代" },
        { value: "50代", label: "50代" },
        { value: "60代", label: "60代" },
        { value: "その他", label: "その他" },
      ],
      sexArr: [
        { value: "男性", label: "男性" },
        { value: "女性", label: "女性" },
        { value: "その他", label: "その他" },
      ],
      selected_age: this.selected_age,
      selected_sex: this.selected_sex,
      default_facet: this.default_facet,
      facet: this.facet,
      facets: this.facets,
      checkedMode: true,
      checkedFacet: false,
      selected_workStatus:'',
      workStatus:[
        {value:'在宅のみ',label:'在宅のみ'},
        {value:'オフィス ',label:'オフィス '}
        ]
      // checkedAge: false,
      // checkedSex: false,
    };
  },

  methods: {
    /**
     * Get the background color for a specific mode type
     * @param {string} modeValue - The mode value (e.g., "チャットボット応対")
     * @returns {string} Hex color code for the mode
     */
    getModeColor(modeValue) {
      const colorMap = {
        "チャットボット応対": "#91d5ff",      // AI Chatbot - Lightest blue
        "AIボイスボット応対": "#69c0ff",      // AI Voicebot - Light blue
        "電話応対": "#40a9ff",                // Phone Mode - Medium blue
        "チャットサポート": "#1890ff",        // Chat Mode - Darker blue
        "F2F応対": "#096dd9"                  // F2F Mode - Darkest blue
      };
      return colorMap[modeValue] || "#1890ff"; // Default to darker blue if not found
    },
    getModeFontColor(modeValue){
      const colorMap = {
        "チャットボット応対": "#2c3e50",      // AI Chatbot - black
        "AIボイスボット応対": "#2c3e50",      // AI Voicebot - black
        "電話応対": "#2c3e50",                // Phone Mode - black
        "チャットサポート": "#fff",        // Chat Mode - white
        "F2F応対": "#fff"                  // F2F Mode - white
      };
      return colorMap[modeValue] || "#fff"; // Default to darker blue if not found

    },

    /**
     * Get the display label for a specific mode value
     * @param {string} modeValue - The mode value (e.g., "チャットボット応対")
     * @returns {string} Display label for the mode (e.g., "AIチャットボット応対")
     */
    getModeLabel(modeValue) {
      const mode = this.modes.find(m => m.value === modeValue);
      return mode ? mode.label : modeValue;
    },

    /**
     * Remove a selected mode item when tag close icon is clicked
     * @param {string} modeValue - The mode value to remove
     */
    removeMode(modeValue) {
      // Remove the mode from the selected array
      const index = this.mode.indexOf(modeValue);
      if (index > -1) {
        this.mode.splice(index, 1);
      }
      // Update the "Select All" checkbox state
      this.getSelectMode(this.mode);
    },

    /**
     * Remove a selected facet item when tag close icon is clicked
     * @param {string} facetLabel - The facet label to remove
     */
    removeFacet(facetLabel) {
      // Remove the facet from the selected array
      const index = this.facet.indexOf(facetLabel);
      if (index > -1) {
        this.facet.splice(index, 1);
      }
      // Update the "Select All" checkbox state and root facet data
      this.getSelectFacet(this.facet);
    },

    ShowDetail() {
      if (this.$root.editMode == false) {
        if (this.$root.allBarShowFlg == true) {
          this.$root.allBarShowFlg = false;
          if (this.$root.historyChatShowFlg == false) {
            this.$root.historyChatHeight = '600px';
          } else if (this.$root.historyChatShowFlg == true) {
            this.$root.historyChatHeight = '100%';
          }
        } else {
          this.$root.allBarShowFlg = true;
          if (this.$root.historyChatShowFlg == false) {
            this.$root.historyChatHeight = '460px';
          } else if (this.$root.historyChatShowFlg == true) {
            this.$root.historyChatHeight = '100%';
          }
        }
      }
    },
    selectChanged(value) {
      if (value.key == moment().format("YYYY-MM")) {
        this.$root.endDate = moment().format("YYYY-MM-DD");
        this.$root.startDate = moment(value.key).startOf("month").format("YYYY-MM-DD");
      } else {
        this.$root.endDate = moment(value.key).endOf("month").format("YYYY-MM-DD");
        this.$root.startDate = moment(value.key).startOf("month").format("YYYY-MM-DD");
      }
      // let startDate = this.$root.startDate;
      // let endDate = this.$root.endDate;
      // this.$bus.$emit("changeEndMonth", startDate, endDate);
    },
    getSelectMode(mode) {
      if (mode.length === this.modes.length) {
        this.checkedMode = true;
      } else {
        this.checkedMode = false;
      }
    },
    getSelectAge() {
      // if (age.length === this.ageArr.length) {
      //   this.checkedAge = true;
      // } else {
      //   this.checkedAge = false;
      // }
      let selectedAge = [];
      selectedAge.push(this.selected_age);
      this.$root.ageForEchart = selectedAge;
    },
    getSelectSex() {
      // if (sex.length === this.sexArr.length) {
      //   this.checkedSex = true;
      // } else {
      //   this.checkedSex = false;
      // }
      let selectedSex = [];
      selectedSex.push(this.selected_sex);
      this.$root.sexForEchart = selectedSex;
    },
    // selectAllAge() {
    //   this.selected_age = [];
    //   if (this.checkedAge) {
    //     this.ageArr.map((item) => {
    //       this.selected_age.push(item.label);
    //     });
    //   } else {
    //     this.selected_age = [];
    //   }
    //   this.$root.ageForEchart = this.selected_age;
    // },
    // selectAllSex() {
    //   this.selected_sex = [];
    //   if (this.checkedSex) {
    //     this.sexArr.map((item) => {
    //       this.selected_sex.push(item.label);
    //     });
    //   } else {
    //     this.selected_sex = [];
    //   }
    //   this.$root.sexForEchart = this.selected_sex;
    // },
    selectAllMode() {
      this.mode = [];
      if (this.checkedMode) {
        this.modes.map((item) => {
          this.mode.push(item.value);
        });
      } else {
        this.mode = [];
      }
    },
    getSelectFacet(facet) {
      if (facet.length === this.facets.length) {
        this.checkedFacet = true;
      } else {
        this.checkedFacet = false;
      }
      this.$root.facetForEchart = this.facet;
    },
    selectAllFacet() {
      this.facet = [];
      if (this.checkedFacet) {
        this.facets.map((item) => {
          this.facet.push(item.label);
        });
      } else {
        this.facet = [];
      }
      this.$root.facetForEchart = this.facet;
    },
    loadInitialCharts(mode) {
      this.$root.facetForEchart = this.facet;
      if (this.selected_age) {
        let selectedAge = [];
        selectedAge.push(this.selected_age);
        this.$root.ageForEchart = selectedAge;
      } else {
        this.$root.ageForEchart = '';
      }

      if (this.selected_sex) {
        let selectedSex = [];
        selectedSex.push(this.selected_sex);
        this.$root.sexForEchart = selectedSex;
      } else {
        this.$root.sexForEchart = '';
      }

      let self = this;
      api.getUserModeEcharts(self.$root.user.user_id, `${mode},共通`).then(
        (res) => {
          if (res && res.data) {
            const list = res.data.userEcharts;
            if (!Array.isArray(list)) {
              return;
            }
            self.$root.usedChartList = [];
            self.$root.unusedChartList = [];
            for (let echart of list) {
              if (echart.checked_flg) {
                let usedChart = {
                  name: echart.name,
                  displayName: echart.displayName,
                  index: echart.index,
                  type: echart.echart_type,
                };
                self.$root.usedChartList.push(usedChart);
              } else {
                let unusedChart = {
                  name: echart.name,
                  displayName: echart.displayName,
                  index: echart.index,
                  type: echart.echart_type,
                };
                self.$root.unusedChartList.push(unusedChart);
              }
            }
            let startDate = self.$root.startDate;
            let endDate = self.$root.endDate;
            self.$bus.$emit("changeEndMonth", startDate, endDate);
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // this.$root.usedChartList = [
      //   {
      //     name: "ChatbotOperateCountChart",
      //     displayName: this.$root.htmlConst.cons_202_category_aggregate_header,
      //   },
      //   {
      //     name: "BuzzWordMapChart",
      //     displayName: this.$root.htmlConst.cons_203_buzz_word_header,
      //   },
      // ];
      // if (mode.includes("チャットボット応対")) {
      //   this.$root.usedChartList.push(
      //     {
      //       name: "ChatbotProcessCountChart",
      //       displayName: this.$root.htmlConst.cons_204_chartbot_category_header,
      //     },
      //     {
      //       name: "ChatbotPeriodCountChart",
      //       displayName: this.$root.htmlConst.cons_205_chatbot_time_header,
      //     },
      //     {
      //       name: "ChatbotSurveyEvaluateChart",
      //       displayName:
      //         this.$root.htmlConst.cons_206_chatbot_satisfaction_header,
      //     },
      //     {
      //       name: "ChatbotSurveyEvaluateBySMSChart",
      //       displayName:
      //         this.$root.htmlConst.cons_207_chatbot_sms_satisfaction_header,
      //     },
      //     {
      //       name: "ChatbotQuestionChart",
      //       displayName: this.$root.htmlConst.cons_208_chatbot_question_header,
      //     },
      //     {
      //       name: "ChatbotAnswerChart",
      //       displayName: this.$root.htmlConst.cons_209_chatbot_answer_header,
      //     }
      //   );
      // }
      // if (mode.includes("電話応対")) {
      //   this.$root.usedChartList.push(
      //     {
      //       name: "AssistantTelphoneProcessCountChart",
      //       displayName: this.$root.htmlConst.cons_210_tel_category_header,
      //     },
      //     {
      //       name: "TelephoneAnswerChart",
      //       displayName: this.$root.htmlConst.cons_211_tel_one_time_header,
      //     },
      //     {
      //       name: "CancelDailPercentChart",
      //       displayName: this.$root.htmlConst.cons_212_tel_abandon_header,
      //     },
      //     {
      //       name: "TelephoneTalkWorkCountChart",
      //       displayName: this.$root.htmlConst.cons_213_tel_time_header,
      //     },
      //     {
      //       name: "TelphoneStatusTimesChart",
      //       displayName: this.$root.htmlConst.cons_214_tel_status_header,
      //     },
      //     {
      //       name: "TelphoneAnswersChooseChart",
      //       displayName: this.$root.htmlConst.cons_215_tel_answer_header,
      //     },
      //     {
      //       name: "TelphoneNGWordsChart",
      //       displayName: this.$root.htmlConst.cons_216_tel_ngword_header,
      //     },
      //     {
      //       name: "TelphoneAverageTimeChart",
      //       displayName: this.$root.htmlConst.cons_230_tel_average_time_header,
      //     }
      //   );
      // }
      // if (mode.includes("F2F応対")) {
      //   this.$root.usedChartList.push(
      //     {
      //       name: "AssistantF2FProcessCountChart",
      //       displayName: this.$root.htmlConst.cons_217_f2f_category_header,
      //     },
      //     {
      //       name: "F2FAnswerChart",
      //       displayName: this.$root.htmlConst.cons_218_f2f_one_time_header,
      //     },
      //     {
      //       name: "F2FStatusTimesChart",
      //       displayName: this.$root.htmlConst.cons_219_f2f_status_header,
      //     },
      //     {
      //       name: "F2FAnswersChooseChart",
      //       displayName: this.$root.htmlConst.cons_220_f2f_answer_header,
      //     },
      //     {
      //       name: "F2FNGWordsChart",
      //       displayName: this.$root.htmlConst.cons_221_f2f_ngword_header,
      //     }
      //   );
      // }
    },

    toggleView() {
      this.loadInitialCharts(this.mode);
    },

    clearClick() {
      this.selected_categroy = this.categroy_list[0];

      this.selected_member = this.member_list[0];
      this.checkedMode = true;
      this.mode = this.default_mode;
      this.checkedFacet = true;
      this.facet = this.default_facet;
      // this.selected_age = this.ageArr[0];
      // this.selected_sex = this.sexArr[0];
      if (this.selected_period.key != this.period_list[0].key) {
        if (this.period_list[0].key == moment().format("YYYY-MM")) {
          this.$root.endDate = moment().format("YYYY-MM-DD");
          this.$root.startDate = moment(this.period_list[0].key).startOf("month").format("YYYY-MM-DD");
        } else {
          this.$root.endDate = moment(this.period_list[0].key).endOf("month").format("YYYY-MM-DD");
          this.$root.startDate = moment(this.period_list[0].key).startOf("month").format("YYYY-MM-DD");
        }
        let startDate = this.$root.startDate;
        let endDate = this.$root.endDate;
        this.$bus.$emit("changeEndMonth", startDate, endDate);
      }
      this.selected_period = this.period_list[0];
    },

    handleClick() {
      if (
        this.checked1 == false ||
        this.checked2 == false ||
        this.checked3 == false ||
        this.checked4 == false
      ) {
        this.checked1 = true;
        this.checked2 = true;
        this.checked3 = true;
        this.checked4 = true;
      } else {
        this.checked1 = false;
        this.checked2 = false;
        this.checked3 = false;
        this.checked4 = false;
      }
    },
    // 展开折叠检索区域
    toggleShowSearchConditions() {
      this.$root.allBarShowFlg = !this.$root.allBarShowFlg;
    }
  },
};
</script>

<style scoped>
.tool-bar-search-conditions {
  padding: 10px 0;
  /* margin-bottom: 20px; */
  text-align: center;
  cursor: pointer;
}

.search-conditions-container {
  padding: 10px 50px 0px 50px;
}

.search-conditions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.search-condition {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 50px;
  row-gap: 20px;
}

.search-condition-item {
  display: flex;
  height: 24px;
  align-items: center;


  .item-label {
    width: 80px;
  }

  .item-select {
    width: 100%;
    padding: 0;
  }
  .base-month-select{
    width: 150px !important;
  }
  .scope-select{
    width: 150px !important;
  }

  :deep(.el-select__tags span .el-tag) {
    height: 16px;
    line-height: 16px;
    border-radius: 2px;
    padding: 0 4px;
  }

  /* .el-select {
    :deep(.el-select__tags span .el-tag) {
      height: 18px;
      line-height: 18px;
    }
  } */
}

.action {
  width: 120px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 5px;
  background-color: #2f70c1;
  color: #fff;
  height: 35px;
}

.action-clear {
  background-color: #fff;
  color: #2f70c1;
}

.action-clear:hover {
  color: #2f70c1;
}

.action-clear:focus {
  color: #2f70c1;
}

/* Styles for selected tags display container */
.selected-tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  /* margin-left: 20px; */
  flex: 1;
}

/* Custom styles for mode tags with colored backgrounds */
.mode-tag {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 16px;
  font-weight: 500;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  line-height: 20px;
}

/* Custom styles for facet tags */
.facet-tag {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 16px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(105, 192, 255);
  color: rgb(255, 255, 255);
  border-color: rgb(105, 192, 255);
  height: 20px;
  line-height: 20px;
}

/* Override for responseType and facet items to allow tags on the right */
.search-condition-item.responseType,
.search-condition-item.facet {
  flex: 0 0 auto;
  min-width: 300px;
}

</style>
